<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>{{title}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickOk"
                >
                    Ok
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text
            style="margin-top: 15px;"
        >
            
            <p v-if="after_error">
                RedChirp was unable to import the file you uploaded because it is in the wrong format.
            </p>

            <p>
                To get the file you wish to upload in the correct format, follow the following steps.
            </p>

            <ol>
                <li>Open the file you wish to upload with Microsoft Excel&reg;</li>
                <li>From the File Menu, choose Save As...</li>
                <li>From the format dropdown, choose Excel Workbook (.xlsx)</li>
                <li>Click the save button</li>
            </ol>    

            <p>
                Frequently this error is caused because the file format is Strict Open XML Spreadsheet (.xlsx) format.  <b>DO NOT USE THIS FORMAT</b>
            </p>

            <p>
                The below screenshots may help.
            </p>

            <img src="@/assets/excel-format-screen-shot-1.png" width="750px" style="max-width: 90%"/>
            <img src="@/assets/excel-format-screen-shot-2.png" width="1050px" style="max-width: 90%"/>
            
            
        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            after_error: false,
        }
    },

    methods: {

        showDialog(after_error)
        {
            this.after_error = after_error == true;
            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
        
           
             // data is valid, so save 
                
            this.dialog = false;
            next(false);
        },

        onClickOk()
        {
            this.closeDialog();
        },
    },

    computed: {
        title() {
            if ( this.after_error )
            {
                return 'Excel File Format Error';
            }

            return 'How to get your file in the correct format';
        }
    },
}
</script>

<style lang="scss" scoped>
</style>